import type { CityConfig } from "../city-template/types";

export const muskogeeConfig: CityConfig = {
  city: "Muskogee",
  state: "Oklahoma",
  stateAbbr: "OK",
  slug: "muskogee",
  route: "/cities/muskogee",
  title: "Emergency Passport Muskogee, OK | Expedited Passport Services | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Muskogee, OK — as fast as 24 hours. Serving Three Rivers area and Eastern Oklahoma. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Muskogee, OK",
  heroSubtitle: "Honor Heights Azalea Festival trip to Japan with two weeks notice? Three Rivers getaway to Mexico and your passport expired? Business trip to London from Green Country with no valid documents? We help Muskogee and Eastern Oklahoma residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Muskogee%20Oklahoma%20Arkansas%20River%20scenic%20waterfront%20historic%20downtown%20brick%20streets%20Honor%20Heights%20Park%20azalea%20gardens%20in%20bloom%20spring%20colors%20Five%20Civilized%20Tribes%20Museum%20Castle%20of%20Muskogee%20Renaissance%20festival%20grounds%20golden%20afternoon%20light%20Green%20Country%20landscape%20professional%20drone%20photography&width=1800&height=700&seq=muskogee-ok-hero-2026&orientation=landscape",
  heroImageAlt: "Muskogee Oklahoma Arkansas River and Honor Heights Park azalea gardens in spring bloom",
  geoPosition: "35.7483;-95.3694",
  geoPlacename: "Muskogee, Oklahoma",
  regionalAgency: {
    name: "Dallas Passport Agency",
    address: "1100 Commerce Street, Suite 900, Dallas, TX 75242",
    distance: "Located in downtown Dallas — approximately 230 miles south of Muskogee via US-69/I-35",
  },
  nearbyCitiesZips: [
    { name: "Muskogee", zips: "74401, 74402, 74403" },
    { name: "Tahlequah", zips: "74464, 74465" },
    { name: "Fort Gibson", zips: "74434" },
    { name: "Wagoner", zips: "74467, 74477" },
    { name: "Pryor", zips: "74361, 74362" },
    { name: "Sallisaw", zips: "74955" },
    { name: "Checotah", zips: "74426" },
    { name: "Eufaula", zips: "74432" },
    { name: "Stilwell", zips: "74960" },
    { name: "McAlester", zips: "74501" },
    { name: "Grove", zips: "74344, 74345" },
    { name: "Claremore", zips: "74017, 74018, 74019" },
    { name: "Okmulgee", zips: "74447" },
    { name: "Warner", zips: "74469" },
    { name: "Hulbert", zips: "74441" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Three Rivers and Eastern Oklahoma departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Green Country Region", desc: "Serving Muskogee, Tahlequah, Fort Gibson, Wagoner, and Eastern Oklahoma" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Tulsa, OK", route: "/cities/tulsa" },
    { name: "Fast passport renewal in Oklahoma City, OK", route: "/cities/oklahoma-city" },
    { name: "Emergency passport help in Broken Arrow, OK", route: "/cities/broken-arrow" },
    { name: "Urgent passport services in Norman, OK", route: "/cities/norman" },
    { name: "Same-day passport help in Dallas, TX", route: "/cities/dallas" },
    { name: "Passport courier services in Arkansas area", route: "/states/arkansas" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Muskogee remotely via secure courier. We do not have a walk-in office in Muskogee — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Muskogee County and Eastern Oklahoma.",
  fpcOfficeAddress: "1200 Main St, Kansas City, Missouri 64105",
  fpcOfficeDistance: "Serving all of Muskogee County and the Eastern Oklahoma region including Cherokee, Wagoner, and McIntosh counties",
  serviceAreaIntro: "From the blooming azaleas of Honor Heights Park and the historic streets of downtown Muskogee to the Cherokee Nation capital of Tahlequah and the Illinois River float trips, from the historic Fort Gibson military site to the shores of Lake Eufaula and Fort Gibson Lake, from the agricultural communities of Checotah and Warner to the growing towns of Wagoner and Pryor — Fast Passport Center serves the entire Green Country and Eastern Oklahoma region. We regularly help travelers from the Three Rivers area get their passports fast without the 230-mile drive to Dallas.",
  nearbyCitiesIntro: "We serve all Muskogee neighborhoods and the surrounding Eastern Oklahoma area including Tahlequah, Fort Gibson, Wagoner, Pryor, Checotah, and Eufaula. If you are anywhere in Muskogee County, Cherokee County, or Wagoner County, we have you covered.",
  howItWorksIntro: "Most Muskogee travelers complete everything online and ship documents overnight. No need to drive to Dallas or wait in line at the regional agency.",
  mistakesIntro: "Muskogee travelers often face a 3.5-hour drive to the nearest regional passport agency in Dallas. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Muskogee and Green Country travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Muskogee? Here are the most common ones we hear from Three Rivers and Eastern Oklahoma travelers.",
  statePageRoute: "/states/oklahoma",
  statePageName: "Oklahoma",
  dmvWebsite: "https://oklahoma.gov/dps.html",
  dmvLabel: "Oklahoma DPS — Driver License Services",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Muskogee travelers with immediate departure needs — as fast as 24 hours for urgent international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for Muskogee travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens in Muskogee with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance for Muskogee and Green Country residents with step-by-step guidance." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Cheryl D.",
      location: "Muskogee, OK",
      rating: 5,
      text: "Our Azalea Festival trip to Japan was in 6 days when we found expired passports. Fast Passport Center renewed them in 36 hours. From Honor Heights to Mount Fuji — incredible service!",
      service: "Passport Renewal",
    },
    {
      name: "Mike R.",
      location: "Tahlequah, OK",
      rating: 5,
      text: "Business conference in London booked last minute. Fast Passport Center got my passport in 2 days. Never left Cherokee County. Saved my presentation.",
      service: "Emergency Passport",
    },
    {
      name: "Patricia W.",
      location: "Fort Gibson, OK",
      rating: 5,
      text: "Family reunion cruise to the Bahamas. Fast Passport Center handled all 5 passports in 4 days. Amazing for Three Rivers area families. Can't thank them enough.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "muskogee-ok-1",
      name: "Muskogee Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "525 W Okmulgee Ave",
      city: "Muskogee",
      state: "OK",
      zip: "74401",
      phone: "(918) 687-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Muskogee",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Muskogee facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "muskogee-ok-2",
      name: "Muskogee County Court Clerk",
      type: "County Court Clerk Passport Acceptance",
      address: "220 State St",
      city: "Muskogee",
      state: "OK",
      zip: "74401",
      phone: "(918) 682-7873",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Downtown Muskogee Courthouse",
      website: "https://www.muskogeeonline.org",
      websiteLabel: "Muskogee County Court Clerk",
      notes: "Accepts passport applications. Good alternative to post office. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "muskogee-ok-3",
      name: "Tahlequah Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1101 S Muskogee Ave",
      city: "Tahlequah",
      state: "OK",
      zip: "74464",
      phone: "(918) 456-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "25 miles east of Muskogee",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Cherokee County and NSU area. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "muskogee-ok-4",
      name: "Wagoner Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "210 N Casaver Ave",
      city: "Wagoner",
      state: "OK",
      zip: "74467",
      phone: "(918) 485-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "15 miles northwest of Muskogee",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Wagoner County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "muskogee-ok-5",
      name: "Eufaula Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "131 Selmon Rd",
      city: "Eufaula",
      state: "OK",
      zip: "74432",
      phone: "(918) 689-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "30 miles south of Muskogee",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves McIntosh County and Lake Eufaula area. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 3.5 hour drive to Dallas", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Muskogee photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Muskogee County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Muskogee applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Dallas regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Three Rivers families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Muskogee travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Muskogee." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Muskogee address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Muskogee before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Muskogee for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 3.5-hour drive to Dallas." },
    { q: "How fast can I renew my passport in Muskogee?", a: "Fast Passport Center offers fast passport renewal in Muskogee in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Muskogee?", a: "The nearest regional passport agency to Muskogee is the Dallas Passport Agency, approximately 230 miles south via US-69/I-35. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Muskogee without any in-person agency visit required." },
    { q: "Do you serve Tahlequah and the Cherokee Nation area?", a: "Absolutely. Fast Passport Center serves the entire Green Country region including Muskogee, Tahlequah (Cherokee Nation capital), Fort Gibson, Wagoner, and surrounding communities. Our courier service works seamlessly throughout Muskogee County, Cherokee County, and Wagoner County." },
    { q: "Do you serve the entire Eastern Oklahoma region?", a: "Absolutely. Fast Passport Center serves the entire Eastern Oklahoma region including Muskogee, Tahlequah, Fort Gibson, Wagoner, Pryor, Checotah, Eufaula, and surrounding areas. Our courier service works seamlessly from any address in the Three Rivers and Green Country area." },
    { q: "Can I expedite a child passport in Muskogee?", a: "Yes. Fast Passport Center expedites child passports in Muskogee for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Green Country families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Muskogee with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Dallas Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — Muskogee", address: "1000 W Shawnee St, Muskogee, OK 74401", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — Muskogee", address: "2400 E Shawnee Rd, Muskogee, OK 74403", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — Tahlequah", address: "2001 S Muskogee Ave, Tahlequah, OK 74464", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walmart Supercenter — Wagoner", address: "410 S Dewey Ave, Wagoner, OK 74467", hours: "Mon–Sun: 6AM–11PM" },
  ],
  dmvLocations: [
    {
      name: "Oklahoma DPS — Muskogee",
      address: "2408 W Okmulgee Ave, Muskogee, OK 74401",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Oklahoma DPS — Tahlequah",
      address: "200 S Muskogee Ave, Tahlequah, OK 74464",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Cherokee County. REAL ID available. Appointment recommended.",
      featured: false,
    },
    {
      name: "Oklahoma DPS — Wagoner",
      address: "300 E Cherokee St, Wagoner, OK 74467",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Wagoner County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "MKO",
      name: "Muskogee-Davis Regional Airport",
      distance: "7 miles south of downtown Muskogee",
      address: "1200 S B St, Muskogee, OK 74401",
      note: "Regional airport serving Muskogee. About 12 minutes from downtown. General aviation and charter services.",
      flightUrl: "https://www.cityofmuskogee.com/airport",
      flightLabel: "MKO Airport",
      featured: true,
    },
    {
      code: "TUL",
      name: "Tulsa International Airport",
      distance: "50 miles northwest of Muskogee",
      address: "7777 E Apache St, Tulsa, OK 74115",
      note: "Regional hub with direct flights to major cities. About 50 minutes from Muskogee via US-69/Muskogee Turnpike.",
      flightUrl: "https://www.tulsaairports.com/",
      flightLabel: "TUL Airport",
      featured: false,
    },
    {
      code: "OKC",
      name: "Will Rogers World Airport",
      distance: "130 miles west of Muskogee",
      address: "7100 Terminal Dr, Oklahoma City, OK 73159",
      note: "Major Oklahoma airport with direct flights nationwide. About 2 hours from Muskogee.",
      flightUrl: "https://flyokc.com/",
      flightLabel: "OKC Airport",
      featured: false,
    },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth & Death Certificates", desc: "Order certified Oklahoma birth and death certificates from the Oklahoma State Department of Health Vital Records — online, by mail, or in person.", url: "https://oklahoma.gov/health/health-education/data-and-statistics/vital-records.html" },
    { icon: "ri-hearts-line", label: "Marriage Records", desc: "Request certified marriage certificates from the Muskogee County Court Clerk. Required for name change passport applications.", url: "https://www.muskogeeonline.org" },
    { icon: "ri-file-copy-line", label: "Divorce Decrees", desc: "Obtain certified divorce records through the Muskogee County District Court. Required for name change passport corrections.", url: "https://www.oscn.net/" },
    { icon: "ri-global-line", label: "VitalChek — Nationwide Records", desc: "If your record was issued outside Oklahoma, order certified copies online through VitalChek for delivery in 5–10 business days.", url: "https://www.vitalchek.com/" },
  ],
};